import { render, staticRenderFns } from "./extended-preferences-modal.vue?vue&type=template&id=172dbe04"
import script from "./extended-preferences-modal.vue?vue&type=script&lang=js"
export * from "./extended-preferences-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports